import { useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import api from '../api';

const tourStyles = `
  .driver-popover {
    background: #0d0d1f !important;
    border: 1.5px solid #7c3aed !important;
    border-radius: 14px !important;
    box-shadow: 0 20px 60px rgba(124,58,237,0.35) !important;
    color: #f1f5f9 !important;
    max-width: 300px !important;
  }
  .driver-popover-title {
    font-family: 'Inter', sans-serif !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    color: #f1f5f9 !important;
    margin-bottom: 8px !important;
  }
  .driver-popover-description {
    font-size: 12px !important;
    color: #94a3b8 !important;
    line-height: 1.6 !important;
  }
  .driver-popover-progress-text {
    font-size: 11px !important;
    color: #7c3aed !important;
    font-weight: 600 !important;
  }
  .driver-popover-next-btn {
    background: linear-gradient(135deg,#7c3aed,#6d28d9) !important;
    border: none !important;
    border-radius: 8px !important;
    color: #fff !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    padding: 7px 16px !important;
    cursor: pointer !important;
    text-shadow: none !important;
  }
  .driver-popover-prev-btn {
    background: transparent !important;
    border: 1px solid #1e293b !important;
    border-radius: 8px !important;
    color: #475569 !important;
    font-size: 12px !important;
    padding: 7px 16px !important;
    cursor: pointer !important;
    text-shadow: none !important;
  }
  .driver-popover-close-btn {
    color: #334155 !important;
    font-size: 18px !important;
  }
  .driver-popover-footer {
    margin-top: 14px !important;
    border-top: 1px solid #1e293b !important;
    padding-top: 12px !important;
  }
  .driver-overlay {
    background: rgba(0,0,0,0.6) !important;
  }
`;

const marcarOnboardingCompleto = async () => {
  try {
    await api.patch('/config/agent', { onboarding_completado: true });
  } catch(e) {}
};

export function startModuleTour(moduleId) {
  const tours = {
    dashboard: [
      { popover: { title: '📊 Dashboard — Tu centro de control', description: 'Aquí ves el resumen completo de tu actividad: llamadas realizadas, minutos consumidos, costo del período y tasa de acuerdo.' } },
      { popover: { title: '📈 Gráfica de llamadas por día', description: 'Muestra la evolución diaria. Usa los botones "Área" y "Barras" para cambiar la vista. Haz clic en un día para filtrar la tabla.' } },
      { popover: { title: '🎯 Dona de resultados', description: 'Distribución de acuerdos, rechazos y otros resultados. Haz clic en un sector de la dona para filtrar la tabla de llamadas.' } },
      { popover: { title: '📊 Analytics por campaña', description: 'Selecciona una o más campañas en la parte inferior para ver métricas detalladas: tasa de contacto, efectividad, costo por acuerdo y evolución por barrido.' } },
    ],
    campaigns: [
      { popover: { title: '📣 Campañas — Cómo funciona', description: 'Cada campaña tiene un prompt (instrucciones del agente), un horario de operación y una lista de contactos. El agente llama automáticamente según tu configuración.' } },
      { popover: { title: '➕ Crear campaña', description: 'Haz clic en "+ Nueva campaña". Define el nombre, horario (ej: 8am-8pm lunes a viernes), número de transferencia y el comportamiento del agente.' } },
      { popover: { title: '🤖 Asistente IA para el prompt', description: 'Usa el botón "Asistente IA" para generar automáticamente el prompt. Solo describe qué debe hacer tu agente y la IA lo escribe por ti.' } },
      { popover: { title: '📂 Subir contactos CSV', description: 'Selecciona la campaña y arrastra tu CSV. Columnas requeridas: "nombre" y "telefono". Columnas opcionales: "monto_deuda", "fecha_limite" y cualquier otra que quieras.' } },
      { popover: { title: '🚀 Lanzar campaña', description: 'Con contactos cargados y saldo disponible, presiona "Lanzar". Verás el estimado de duración antes de confirmar. El agente empieza a llamar inmediatamente.' } },
    ],
    calls: [
      { popover: { title: '📋 Llamadas — Tu historial completo', description: 'Aquí ves todas las llamadas realizadas con estado, duración, costo y resultado. Filtra por estado, campaña, barrido o fecha.' } },
      { popover: { title: '🎧 Detalle de cada llamada', description: 'Haz clic en cualquier fila para expandir el detalle: transcripción completa de la conversación, grabación de audio reproducible y descargable.' } },
      { popover: { title: '📤 Exportar CSV', description: 'Usa el botón "Exportar CSV" para descargar el historial filtrado. Útil para reportes o análisis externos.' } },
    ],
    config: [
      { popover: { title: '⚙️ Agente — Configuración de tu IA', description: 'Aquí configuras todo sobre cómo suena y se comporta tu agente de voz.' } },
      { popover: { title: '🎙️ Voz del agente', description: 'Elige entre nuestras voces exclusivas (Andrea o Esmeralda) o clona una voz personalizada. Para clonar, sube un audio de 30+ segundos con voz clara y sin ruido.' } },
      { popover: { title: '🤖 Herramientas del agente', description: 'Configura qué acciones puede ejecutar tu agente: registrar acuerdos, rechazos, transferir a humano, etc. Cada herramienta tiene parámetros personalizables.' } },
    ],
    billing: [
      { popover: { title: '💰 Facturación — Tu saldo y consumo', description: 'Aquí controlas tu saldo disponible, recargas y analizas cuánto gastas por campaña y por día.' } },
      { popover: { title: '⚡ Recargar saldo', description: 'Selecciona un monto rápido ($50k, $100k, $200k, $500k) o escribe uno personalizado. Mínimo $50.000 COP. Pago seguro vía Wompi, se acredita de inmediato.' } },
      { popover: { title: '📊 Filtros de análisis', description: 'Filtra por período (Hoy, 7 días, 30 días o personalizado) y por campaña para ver exactamente en qué se usa tu saldo. La tarjeta de resumen se actualiza en tiempo real.' } },
      { popover: { title: '📤 Exportar reportes', description: 'Usa "Exportar informe" para descargar el consumo por día en CSV. Usa "Exportar recargas" para el historial de pagos.' } },
    ],
    activity: [
      { popover: { title: '🔍 Actividad — Tu bitácora de seguridad', description: 'Registro de todas las acciones importantes en tu cuenta: inicios de sesión, campañas lanzadas, recargas y cambios de configuración.' } },
      { popover: { title: '🔐 Seguridad', description: 'Si ves un inicio de sesión desde una IP desconocida, contacta a soporte inmediatamente. Cada acción queda registrada con fecha, hora e IP.' } },
    ],
  };

  const steps = tours[moduleId] || [];
  if (!steps.length) return;

  const driverObj = driver({
    showProgress: true,
    progressText: '{{current}} de {{total}}',
    nextBtnText: 'Siguiente →',
    prevBtnText: '← Atrás',
    doneBtnText: '¡Entendido! ✓',
    overlayOpacity: 0.6,
    smoothScroll: true,
    steps,
  });
  driverObj.drive();
}

export default function OnboardingTour({ navigate }) {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = tourStyles;
    document.head.appendChild(style);

    // Verificar si ya completó el onboarding via campo en perfil local
    const clienteData = localStorage.getItem('cliente_data');
    if (clienteData) {
      try {
        const parsed = JSON.parse(clienteData);
        if (parsed.onboarding_completado) return;
      } catch(e) {}
    }

    // También verificar en la API
    api.get('/config/agent').then(r => {
      if (r.data?.onboarding_completado) {
        // Guardar en localStorage para próximas cargas
        const existing = JSON.parse(localStorage.getItem('cliente_data') || '{}');
        localStorage.setItem('cliente_data', JSON.stringify({ ...existing, onboarding_completado: true }));
        return;
      }

      const driverObj = driver({
        showProgress: true,
        progressText: '{{current}} de {{total}}',
        nextBtnText: 'Siguiente →',
        prevBtnText: '← Atrás',
        doneBtnText: '¡Listo! 🚀',
        overlayOpacity: 0.6,
        smoothScroll: true,
        onDestroyStarted: () => {
          marcarOnboardingCompleto();
          const existing = JSON.parse(localStorage.getItem('cliente_data') || '{}');
          localStorage.setItem('cliente_data', JSON.stringify({ ...existing, onboarding_completado: true }));
          driverObj.destroy();
        },
        steps: [
          {
            popover: {
              title: '👋 Bienvenido a InnovaCall',
              description: 'En menos de 5 minutos tendrás tu primer agente de voz IA haciendo llamadas reales. Te guiamos paso a paso.',
              side: 'over',
            }
          },
          {
            element: '#nav-billing',
            popover: {
              title: '💳 Paso 1: Recarga tu saldo',
              description: 'Sin saldo no hay llamadas. Recarga mínimo $50.000 COP para empezar. Haz clic en Facturación en el menú.',
              side: 'right', align: 'start',
            }
          },
          {
            element: '#nav-campaigns',
            popover: {
              title: '📣 Paso 2: Crea una campaña',
              description: 'Define el nombre, horario y el prompt de tu agente. El asistente IA te ayuda a escribirlo.',
              side: 'right', align: 'start',
            }
          },
          {
            element: '#nav-campaigns',
            popover: {
              title: '📂 Paso 3: Sube tus contactos',
              description: 'Arrastra un CSV con columnas "nombre" y "telefono". Puedes agregar columnas extra y el agente las usará.',
              side: 'right', align: 'start',
            }
          },
          {
            element: '#nav-config',
            popover: {
              title: '🎙️ Paso 4: Configura tu agente',
              description: 'Elige la voz, ajusta el comportamiento y opcionalmente clona una voz personalizada.',
              side: 'right', align: 'start',
            }
          },
          {
            popover: {
              title: '🚀 ¡Todo listo!',
              description: 'Con saldo, campaña y contactos listos, presiona "Lanzar". Tu agente IA empieza a llamar. Usa el botón ? en cada sección para más ayuda.',
              side: 'over',
            }
          },
        ],
      });

      setTimeout(() => driverObj.drive(), 1000);
    }).catch(() => {});

    return () => {};
  }, [navigate]);

  return null;
}
